import React, { useEffect, useState } from 'react'       //Create a functional component rafce
import Header from './components/header/Header'
import Nav from './components/nav/Nav'
import About from './components/about/About'
import Experience from './components/experience/Experience'
import Services from './components/services/Services'
import Portfolio from './components/portfolio/Portfolio'
import Testimonilas from './components/testimonials/Testimonilas'
import Contact from './components/contact/Contact'
import Footer from './components/footer/Footer'

import { PropagateLoader } from 'react-spinners'

const App = () => {

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 4000)
  }, []);

  return (
    <>
      {loading ? (
      <div className='spinner'>
        <PropagateLoader
          color="var(--color-primary)"
          size={20}
        />

      </div>    
        
      ) : (
        <>
          <Header />
          <Nav />
          <About />
          <Experience />
          <Services />
          <Portfolio />
          <Testimonilas />
          <Contact />
          <Footer />
        </>

      )}
    </>
  )
}

export default App

